import r from "./_getLength.js";
import e from "./_isArrayLike.js";
import t from "./isArray.js";
import f from "./isArguments.js";
function i(o, s, n, a) {
  if (a = a || [], s || 0 === s) {
    if (s <= 0) return a.concat(o);
  } else s = 1 / 0;
  for (var m = a.length, l = 0, g = r(o); l < g; l++) {
    var p = o[l];
    if (e(p) && (t(p) || f(p))) {
      if (s > 1) i(p, s - 1, n, a), m = a.length;else for (var u = 0, h = p.length; u < h;) a[m++] = p[u++];
    } else n || (a[m++] = p);
  }
  return a;
}
export { i as default };